import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 100,
    },
    tableWrapper: {
        overflowX: 'auto',
    }
});

const CustomTableCell = withStyles(theme => ({
    head: {
        fontSize: 14,
        textAlign: 'center'
    },
    body: {
        fontSize: 12,
        padding: 20,
        minWidth: 80
    }
}))(TableCell);

class AggregatesTable extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            aggregatesData: [],
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.aggregationTypes !== this.props.aggregationTypes || nextProps.groupAggTypes !== this.props.groupAggTypes) {
            this.setAggregatesData(nextProps.aggregationTypes, nextProps.groupAggTypes);
        }
    }

    setAggregatesData(allAggTypes, groupAggTypes) {
        if (allAggTypes != null && groupAggTypes != null) {
            let aggregatesData = [];
            for (let groupType of groupAggTypes) {
                let namedType = allAggTypes.find(aaType => {
                    return groupType.aggregationTypeId == aaType.id;
                });
                typeof namedType != 'undefined' ?
                    aggregatesData.push({
                        value: groupType.attribute + ' (' + namedType.name + ')',
                        name: groupType.attribute + ' (' + namedType.name + ')'
                    }) : null
            }

            this.setState({
                aggregatesData: aggregatesData
            });
        }
    }

    render() {
        const {classes} = this.props;
        const {aggregatesData} = this.state;

        return (
            <div className={classes.root}>
                <Paper>
                    <div className={classes.tableWrapper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <CustomTableCell
                                        style={{fontSize: 18}}
                                        colSpan={1}
                                        key={'aggs'}
                                        numeric={false}
                                        padding={'default'}>
                                        <b>Aggregates</b>
                                    </CustomTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {aggregatesData.map((aggregate, idx) => {
                                    return (
                                        <TableRow key={idx}>
                                            <CustomTableCell style={{fontSize: 17}}>
                                                {aggregate.name}
                                            </CustomTableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </div>
                </Paper>
            </div>
        );
    }
}

AggregatesTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AggregatesTable);



// WEBPACK FOOTER //
// ./src/main/content/query/tables/AggregatesTable.js